import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Empty_General_Group_Interface, General_Group_Interface } from 'src/app/Interface/General_Group_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { DocumentTitleService } from 'src/app/Service/DocumentTitle/DocumentTitle.service';
import { DocumentGroupService } from 'src/app/Service/DocumentGroup/DocumentGroup.service';
import { General_Interface } from 'src/app/Interface/General_Interface';

@Component({
  selector: 'app-DocumentTitleAdd',
  templateUrl: './DocumentTitleAdd.component.html',
  styleUrls: ['./DocumentTitleAdd.component.scss']
})
export class DocumentTitleAddComponent implements OnInit {

  constructor(
    private DocumentTitle_Service:DocumentTitleService,
    private Nav_Service:NavService,
    private DocumentGroup_Service:DocumentGroupService,
    private Alertify_Service:AlertifyService
  ) { }

  ngOnInit() {

    this.AddNewDocumentTitle=new FormGroup({
      id :new FormControl(),
      Title:new FormControl(null,Validators.required),
      GroupId:new FormControl("0",Validators.required),
    })


    this.Nav_Service.CheckValidPage(27).subscribe(
      data=>{
        this.ReadData_DocumentGroup()
      }
      ,error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )


  }

  DataList_DocumentGroup:Array<General_Interface>=[]
  ReadData_DocumentGroup(){
    this.DocumentGroup_Service.GetActiveList().subscribe(
      data=>{
        this.DataList_DocumentGroup=data
      },error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }

  //#region  Form Add

  AddNewDocumentTitle:FormGroup;

  get_Form_Title(){
    return this.AddNewDocumentTitle.get('Title') as FormControl;
  }
  get_Form_GroupId(){
    return this.AddNewDocumentTitle.get('GroupId') as FormControl;
  }

  //#endregion

  InProccessing:boolean=false

  SubmitAddNewDocumentTitle(){

    if(this.get_Form_GroupId().value=="0")
    {
      this.Alertify_Service.ErrorMessage("گروه اسناد را انتخاب نمائید")
    }
    else{
      var Record:General_Group_Interface =Empty_General_Group_Interface()
      Record.id=0
      Record.title=this.get_Form_Title().value
      Record.group_id=Number(this.get_Form_GroupId().value)

      console.log(Record);


      this.InProccessing=true
      this.DocumentTitle_Service.AddDocumentTitle(Record).subscribe(
        data=>{
          this.InProccessing=false
          if(data.id==-2){
            this.Alertify_Service.ErrorMessage("عنوان وارد شده ، در لیست وجود دارد")
          }
          else{
            this.AddNewDocumentTitle.reset()
            this.get_Form_GroupId().setValue("0")
            this.Alertify_Service.SuccessMessage("اطلاعات ثبت شد")
          }
        },error=>{
          // AuthInterceptor owns authentication; feature errors must preserve credentials.

        }
      )
    }
  }



}
